import { Component, OnDestroy, OnInit } from '@angular/core';
import { Searcher } from '@3ddv/ngx-sites-builder-lib';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SblibService } from '../../services/sblib.service';
import { ToolsService } from '../services/tools.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { Workflow } from '@3ddv/ngx-sites-builder-lib/lib/workflows/models/workflow.model';

@Component({
  selector: 'app-sbeditor-tool-searcher',
  templateUrl: './searcher.component.html',
  styleUrls: ['./searcher.component.scss'],
})
export class SearcherComponent implements OnInit, OnDestroy {
  public postedFile;
  public tool: Searcher;
  private subscriptions: Array<Subscription>;
  public downloadTemplate: SafeUrl;
  public workflow: Workflow;
  //public editorOptions: JsonEditorOptions;

  constructor(
    private toolsService: ToolsService,
    private sanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private sblibService: SblibService
  ) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }
  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (res.searcher) {
        this.tool = JSON.parse(JSON.stringify(res.searcher));
        if (!this.tool.order) {
          this.tool.order = 'json';
        }
      } else {
        console.error('searcher tool not found');
        return;
      }
    });
    this.subscriptions.push(tools$);
    this.generateTemplate();
    this.workflow = this.activatedRoute.snapshot.data.dataFlow.workflow;
    console.log(this.workflow);
  }

  private readFile(file) {
    this.postedFile = file;
    const fileReader = new FileReader();
    fileReader.readAsText(this.postedFile);
    fileReader.onload = _event => {
      try {
        /*      this.editorOptions = new JsonEditorOptions();
        this.editorOptions.modes = ['tree']; */
        let data_string = fileReader.result.toString();
        this.tool.fileData = JSON.parse(data_string);
        this.downloadTemplate = this.sanitizer.bypassSecurityTrustUrl(
          'data:text/json;charset=UTF-8,' + encodeURIComponent(data_string)
        );
      } catch (e) {
        this.toastrService.error('', 'Bad JSON file');
      }
      //this.editJSON = JSON.stringify(this.tool.fileData,null,2);
    };
  }

  public onFileSelected($event) {
    this.postedFile = null;
    if (!$event.target.files.length) return;

    if (
      ($event.target.files[0].type == '' && $event.target.files[0].size == 0) ||
      $event.target.files[0].type != 'application/json'
    ) {
      this.toastrService.error('', 'Formato del fichero inválido');
      return;
    }

    this.readFile($event.target.files[0]);
  }

  public onFileDropped($event) {
    this.postedFile = null;
    if (!$event.length) return;

    if (($event[0].type == '' && $event[0].size == 0) || $event[0].type != 'application/json') {
      this.toastrService.error('', 'Formato del fichero inválido');
      return;
    }

    this.readFile($event[0]);
  }

  public deleteDroppedFile() {
    this.postedFile = null;
    this.tool.fileData = {};
    this.generateTemplate();
  }

  public apply() {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      res.searcher = JSON.parse(JSON.stringify(this.tool));
      this.sblibService.apply(res);
      this.toastrService.success('', 'Success');
    });
    this.subscriptions.push(tools$);
  }

  private generateTemplate(): void {
    let template = {
      S_123: {
        row1: ['1', '2', '3'],
        row2: ['1', '2', '3'],
        row3: ['1', '2', '3'],
      },
    };
    let data = JSON.stringify(template, null, 2);
    this.downloadTemplate = this.sanitizer.bypassSecurityTrustUrl(
      'data:text/json;charset=UTF-8,' + encodeURIComponent(data)
    );
  }
}
